import { createFileRoute } from "@tanstack/react-router"

import { newsroomHead } from "./-components/newsroom"
import { NewsroomPage } from "./-components/NewsroomPage"
import { PressReleaseList } from "./-components/PressReleaseList"

export const Route = createFileRoute("/_content/news/")({
  head: () => newsroomHead("releases"),
  component: () => (
    <NewsroomPage category="releases">
      <PressReleaseList />
    </NewsroomPage>
  ),
})
